module.exports = require("quickselect");